import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import i18n from 'i18next';
import { Route, Switch, Redirect, Link } from 'react-router-dom';
import App from './app';
import TrafficLive from './trafficLive';
import StatsDashboard from './statsDashboard';
import VesselsDashboard from './vesselsDashboard';
import LineDashboard from './lineDashboard';
import TerminalDashboard from './terminalDashboard';
import TrafficDashboard from './trafficDashboard';
import LogisticDeliver from './logisticDeliver';
import LogisticDriver from './logisticDriver';
import EventManagement from './eventManagement';
import LiveMessage from './liveMessage';
import TrafficPrediction from './trafficPrediction';
import TrafficStatistic from './trafficStatistic';
import UserManagement from './userManagement';
import Mape from './setting/mape';
import Service from './setting/service';
import Device from './setting/device';
import Billboard from './setting/billboard';
import TerminalBoard from './setting/terminalBoard';
import Feedback from './setting/feedback';
import AuditLog from './setting/auditLog';
import AuditLogStatistics from './setting/auditLogStatistics';
import BillboardView from './board/billboardView';
import TerminalBoardView from './board/terminalBoardView';
import ForgotPassword from './forget-password';
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var initialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
export function changeTitle(title) {
  var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isManagementMode = arguments.length > 2 ? arguments[2] : undefined;
  var prefix = isManagementMode ? gt('title') : gt('front-platform-title');
  var result = prefix;

  if (!override) {
    if (!title) {
      result = prefix;
    } else {
      result = "".concat(prefix, " | ").concat(title);
    }
  } else {
    result = title;
  }

  if (document.title !== result) {
    document.title = result;
  }
}

var NoMatch = /*#__PURE__*/function (_React$Component) {
  _inherits(NoMatch, _React$Component);

  var _super = _createSuper(NoMatch);

  function NoMatch() {
    _classCallCheck(this, NoMatch);

    return _super.apply(this, arguments);
  }

  _createClass(NoMatch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      changeTitle(et('title-error'));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      changeTitle(et('title-error'));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, et('not-found'));
    }
  }]);

  return NoMatch;
}(React.Component);

var checkIsInclude = function checkIsInclude(mode, rights, key) {
  if (rights.indexOf("".concat(mode, ".").concat(key)) >= 0) return true;
  return false;
};

export var routes = function routes() {
  var isManagementMode = initialState.envCfg.isManagementMode,
      rights = initialState.sessionObj.rights;
  var mode = isManagementMode ? 'evms' : 'web';

  var renderRedirect = function renderRedirect() {
    var directPages = [['map', '/map'], ['dashboard.performance', '/dashboard/performance'], ['dashboard.vessel', '/dashboard/vessel'], ['dashboard.line', '/dashboard/line'], ['dashboard.terminal', '/dashboard/terminal'], ['dashboard.traffic', '/dashboard/traffic'], ['logistic.deliver', '/logistic/deliver'], ['logistic.driver', '/logistic/driver'], ['board.billboardView', '/board/billboardView'], ['board.terminalBoardView', '/board/terminalBoardView'], ['event', '/event'], // ['message', '/message'],
    ['traffic.prediction', '/traffic/prediction'], ['traffic.statistic', '/traffic/statistic'], ['user', '/user'], ['setting.mape', '/setting/mape'], ['setting.service', '/setting/service'], ['setting.device', '/setting/device'], ['setting.billboard', '/setting/billboard'], ['setting.terminalBoard', '/setting/terminalBoard'], ['setting.feedback', '/setting/feedback'], ['setting.auditLog', '/setting/auditLog'], ['setting.auditLogTargetStatistics', '/setting/auditLogTargetStatistics']];
    var i = 0;
    var path = '/map';

    while (i < directPages.length) {
      if (rights.indexOf("".concat(mode, ".").concat(directPages[i][0])) >= 0) {
        path = directPages[i][1];
        break;
      }

      i++;
    }

    return /*#__PURE__*/React.createElement(Redirect, {
      from: '/app/',
      exact: true,
      to: path
    });
  };

  return /*#__PURE__*/React.createElement(App, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: '/forgotPassword',
    component: ForgotPassword
  }), renderRedirect(), checkIsInclude(mode, rights, 'map') && /*#__PURE__*/React.createElement(Route, {
    path: '/map',
    component: TrafficLive
  }), checkIsInclude(mode, rights, 'dashboard.performance') && /*#__PURE__*/React.createElement(Route, {
    path: '/dashboard/performance',
    component: StatsDashboard
  }), checkIsInclude(mode, rights, 'dashboard.vessel') && /*#__PURE__*/React.createElement(Route, {
    path: '/dashboard/vessel',
    component: VesselsDashboard
  }), checkIsInclude(mode, rights, 'dashboard.line') && /*#__PURE__*/React.createElement(Route, {
    path: '/dashboard/line',
    component: LineDashboard
  }), checkIsInclude(mode, rights, 'dashboard.terminal') && /*#__PURE__*/React.createElement(Route, {
    path: '/dashboard/terminal',
    component: TerminalDashboard
  }), checkIsInclude(mode, rights, 'dashboard.traffic') && /*#__PURE__*/React.createElement(Route, {
    path: '/dashboard/traffic',
    component: TrafficDashboard
  }), checkIsInclude(mode, rights, 'logistic.deliver') && /*#__PURE__*/React.createElement(Route, {
    path: '/logistic/deliver',
    component: LogisticDeliver
  }), checkIsInclude(mode, rights, 'logistic.driver') && /*#__PURE__*/React.createElement(Route, {
    path: '/logistic/driver',
    component: LogisticDriver
  }), checkIsInclude(mode, rights, 'board.billboardView') && /*#__PURE__*/React.createElement(Route, {
    path: '/board/billboardView',
    component: BillboardView
  }), checkIsInclude(mode, rights, 'board.terminalBoardView') && /*#__PURE__*/React.createElement(Route, {
    path: '/board/terminalBoardView',
    component: TerminalBoardView
  }), checkIsInclude(mode, rights, 'event') && /*#__PURE__*/React.createElement(Route, {
    path: '/event',
    component: EventManagement
  }), checkIsInclude(mode, rights, 'traffic.prediction') && /*#__PURE__*/React.createElement(Route, {
    path: '/traffic/prediction',
    component: TrafficPrediction
  }), checkIsInclude(mode, rights, 'traffic.statistic') && /*#__PURE__*/React.createElement(Route, {
    path: '/traffic/statistic',
    component: TrafficStatistic
  }), checkIsInclude(mode, rights, 'user') && /*#__PURE__*/React.createElement(Route, {
    path: '/user',
    component: UserManagement
  }), checkIsInclude(mode, rights, 'setting.mape') && /*#__PURE__*/React.createElement(Route, {
    path: '/setting/mape',
    component: Mape
  }), checkIsInclude(mode, rights, 'setting.service') && /*#__PURE__*/React.createElement(Route, {
    path: '/setting/service',
    component: Service
  }), checkIsInclude(mode, rights, 'setting.device') && /*#__PURE__*/React.createElement(Route, {
    path: '/setting/device',
    component: Device
  }), checkIsInclude(mode, rights, 'setting.billboard') && /*#__PURE__*/React.createElement(Route, {
    path: '/setting/billboard',
    component: Billboard
  }), checkIsInclude(mode, rights, 'setting.terminalBoard') && /*#__PURE__*/React.createElement(Route, {
    path: '/setting/terminalBoard',
    component: TerminalBoard
  }), checkIsInclude(mode, rights, 'setting.feedback') && /*#__PURE__*/React.createElement(Route, {
    path: '/setting/feedback',
    component: Feedback
  }), checkIsInclude(mode, rights, 'setting.auditLog') && /*#__PURE__*/React.createElement(Route, {
    path: '/setting/auditLog',
    component: AuditLog
  }), checkIsInclude(mode, rights, 'setting.auditLogTargetStatistics') && /*#__PURE__*/React.createElement(Route, {
    path: '/setting/auditLogTargetStatistics',
    component: AuditLogStatistics
  }), /*#__PURE__*/React.createElement(Route, {
    component: NoMatch
  })));
};